import { Button } from '@material-ui/core'
import React from 'react'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Admin, Auth, User } from '../../../types'
import { logout } from '../../../state/Firebase/operations'

export type Props = {
  user: User | Admin | null
  auth: Auth
  title?: string
}

const NavBar = (props: Props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  if (!props.user) return <div>loading</div>

  return (
    <div>
      <AppBar position="static" color="secondary">
        <Toolbar>
          <Typography
            onClick={() => navigate('/')}
            variant="h6"
            color="inherit"
            style={{ flex: 1, cursor: 'pointer' }}
          >
            {props.title}
          </Typography>
          <Typography
            variant="h6"
            color="inherit"
            style={{ marginRight: '12px' }}
          >
            {props.user.label}
          </Typography>
          <Button
            variant="text"
            onClick={async () => {
              await dispatch(logout())
              navigate('/login')
            }}
            style={{ marginTop: 0 }}
            color="inherit"
          >
            ログアウト
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  )
}

NavBar.defaultProps = { title: '運用サイト' }

export default NavBar
